import PageContainer from 'common/PageContainer';
import PartnerBookings from './component/PartnerBookings';
import PartnerDetail from './component/PartnerDetail/index'

const PartnerDetails = () => {
  return (
    <PageContainer>
      {
        <>
        {/* <h1>hitu</h1> */}
          <PartnerDetail />
          <PartnerBookings />
        </>
      }
    </PageContainer>
  );
};

export default PartnerDetails;